import { computed } from 'vue'
import { useFeatureFlagsStore } from '@/stores'

/**
 * Composable for accessing feature flags in components.
 * Provides reactive access to feature flags from the database.
 */
export function useFeatureFlags() {
  const store = useFeatureFlagsStore()

  return {
    // Dynamic flag checker - use this for any flag
    isEnabled: (category: string, name: string) => computed(() => store.isEnabled(category, name)),

    // Support features (backward compatibility)
    supportTicketEnabled: computed(() => store.isEnabled('support', 'ticketForm')),
    liveChatEnabled: computed(() => store.isEnabled('support', 'liveChat')),
    floatingHelpEnabled: computed(() => store.isEnabled('support', 'floatingHelp')),

    // Payment features (backward compatibility)
    invoicesEnabled: computed(() => store.isEnabled('payments', 'invoices')),

    // Store state
    loaded: computed(() => store.loaded),
    loading: computed(() => store.loading),
    error: computed(() => store.error),

    // Full flags object (for advanced usage)
    flags: computed(() => store.flags),

    // Actions
    refresh: () => store.refresh()
  }
}
